module.exports = __webpack_public_path__ + "static/media/emergency_department.bdca3659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emergency_department.jpg
// module id = 842
// module chunks = 0